export const EXPORT_WATCH_LIST_ENTRIES_CSV_MESSAGES = {
  NOT_FOUND: 'No report was found',
};

export const EXPORT_WATCH_LIST_All_ENTRIES_CSV_MESSAGES = {
  NOT_FOUND: 'No report was found',
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/constants/exportWatchListEntriesCsvMessages.js